/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  ADD_INBOX_DATA,
  ADD_CASE_DETAILS,
  ADD_PATHOLOGIST_PENDING_DATA,
  UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS,
  ADD_PATHOLOGIST_COMPLETED_DATA,
  UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS,
  UPDATE_INBOX_DATA_FETCH_INPROGRESS,
  ADD_RECENTLY_RELEASED_DATA,
  UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS,
  RECEIVE_PATHOLOGISTS_SLIDES_DATA,
  RECEIVE_PATHOLOGISTS_SLIDES_DATA_ERROR,
  COMPLETE_CASE_DATA,
  COMPLETE_CASE_DATA_ERROR,
  LAUNCH_PREMERIS_DATA,
  LAUNCH_PREMERIS_DATA_ERROR,
  INBOX_ERROR,
  FILTER_PAYLOAD,
  UPDATE_FREEZE_STATUS_SUCCESS,
  UPDATE_FREEZE_STATUS_ERROR,
} from '../../../actions'

const defaultInboxState = {
  data: [],
  fetchInProgress: false,
  error: false,
}
export const addInboxDataReducer = (state = defaultInboxState, action) => {
  switch (action.type) {
    case ADD_INBOX_DATA:
      return { ...state, ...action?.payload, error: false }
    case UPDATE_INBOX_DATA_FETCH_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    case INBOX_ERROR:
      return { ...state, error: true }
    default:
      return state
  }
}

export const addPendingDataReducer = (state = { data: [], fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_PATHOLOGIST_PENDING_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action?.inProgress }
    default:
      return state
  }
}

const defaultCompletedInboxState = {
  data: [],
  fetchInProgress: false,
  error: false,
}

export const addCompletedDataReducer = (state = defaultCompletedInboxState, action) => {
  switch (action.type) {
    case ADD_PATHOLOGIST_COMPLETED_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action?.inProgress }
    default:
      return state
  }
}

export const addCaseDetailsReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case ADD_CASE_DETAILS:
      return { ...state, [action.mdid]: action.payload }

    default:
      return state
  }
}

export const addRecentlyReleasedDataReducer = (state = { data: [], fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_RECENTLY_RELEASED_DATA:
      return { ...state, ...action?.payload }
    case UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS:
      return { ...state, fetchInProgress: action?.inProgress }
    default:
      return state
  }
}

const default_re_slide_state = {
  re_slide_success: false,
  re_slide_error: false,
  re_slide_data: {},
}

export const receivePathologistsSlidesDataReducer = (state = default_re_slide_state, action) => {
  switch (action.type) {
    case RECEIVE_PATHOLOGISTS_SLIDES_DATA:
      return { ...state, re_slide_data: action.payload, re_slide_success: true, re_slide_error: false }
    case RECEIVE_PATHOLOGISTS_SLIDES_DATA_ERROR:
      return { ...state, re_slide_data: action.payload, re_slide_success: false, re_slide_error: true }
    default:
      return state
  }
}

const default_re_complete_state = {
  re_complete_success: false,
  re_complete_error: false,
  re_complete_data: {},
}

export const completeCaseDataResponseReducer = (state = default_re_complete_state, action) => {
  switch (action.type) {
    case COMPLETE_CASE_DATA:
      return { ...state, re_complete_data: action.payload, re_complete_success: true, re_complete_error: false }
    case COMPLETE_CASE_DATA_ERROR:
      return { ...state, re_complete_data: action.payload, re_complete_success: false, re_complete_error: true }
    default:
      return state
  }
}

const default_freeze_state = {
  re_freeze_success: false,
  re_freeze_error: false,
}

export const freezeCaseReducer = (state = default_freeze_state, action) => {
  switch (action.type) {
    case UPDATE_FREEZE_STATUS_SUCCESS:
      return { ...state, re_freeze_success: true, re_freeze_error: false }
    case UPDATE_FREEZE_STATUS_ERROR:
      return { ...state, re_freeze_success: false, re_freeze_error: true }
    default:
      return state
  }
}

const default_re_launch_state = {
  re_launch_success: false,
  re_launch_error: false,
  re_launch_data: {},
}

export const launchPremerisDataResponseReducer = (state = default_re_launch_state, action) => {
  switch (action.type) {
    case LAUNCH_PREMERIS_DATA:
      return { ...state, re_launch_data: action.payload, re_launch_success: true, re_launch_error: false }
    case LAUNCH_PREMERIS_DATA_ERROR:
      return { ...state, re_launch_data: action.payload, re_launch_success: false, re_launch_error: true }
    default:
      return state
  }
}

export const filterPayloadResponseReducer = (state = {}, action) => {
  switch (action.type) {
    case FILTER_PAYLOAD:
      return { ...action.payload }
    default:
      return state
  }
}
